/**
 * Number Formatting Utilities
 * Common formatters used across the application
 */

/**
 * Format amount with 2 decimal places
 * @param {number|string} val - The value to format
 * @returns {string} - Formatted amount (e.g., "10.00")
 */
export function amountDecimalNumberFormatter(val) {
  if (val) {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(val);
  } else {
    return '0.00';
  }
}

/**
 * Format amount with thousand separators and 2 decimal places
 * @param {number|string} val - The value to format
 * @returns {string} - Formatted amount (e.g., "1,234.56")
 */
export function amountNumberFormatter(val) {
  if (val) {
    var formattedNumber = val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return formattedNumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else {
    return '0.00';
  }
}

/**
 * Format number with thousand separators (no decimals)
 * @param {number|string} val - The value to format
 * @returns {string|number} - Formatted number
 */
export function pointNumberFormatter(val) {
  if (val) {
    let nf = new Intl.NumberFormat('en-US');
    return nf.format(val);
  } else {
    return 0;
  }
}

